import {
  ClienteHttpBase,
  type DependenciasInternasHttp,
  type RequisicaoHttp,
} from '../cliente-http-base'
import type { ClienteHttp, HeadersHttp } from '../http.tipos'

const TIMEOUT_PADRAO_MS = 50_000

const HEADERS_GERENCIADOS = new Set([
  'authorization',
  'x-pontotel-authorization',
  'x-pontotel-up',
  'x-pontotel-di',
  'x-perfil-acesso',
  'accept-language',
])

export type CredenciaisCondominio = Readonly<{
  authorization?: string | null
  accessToken?: string | null
  userPoolId?: string | null
  userPoolWebClientId?: string | null
}>

export type DependenciasClienteHttpCondominio = Readonly<{
  urlBase: string
  urlFallback: string
  timeoutMs?: number
  obterCredenciais: () => CredenciaisCondominio | null | undefined
  obterPerfilAcesso: () => string | null | undefined
  obterIdioma: () => string | null | undefined
}>

const obterValorPreenchido = (valor: string | null | undefined): string | undefined => (
  valor !== undefined && valor !== null && valor.trim().length > 0
    ? valor
    : undefined
)

const removerHeadersGerenciados = (headers: HeadersHttp | undefined): Record<string, string> => {
  const resultado: Record<string, string> = {}

  for (const [nome, valor] of Object.entries(headers ?? {})) {
    if (!HEADERS_GERENCIADOS.has(nome.toLowerCase())) resultado[nome] = valor
  }

  return resultado
}

export class ClienteHttpCondominio extends ClienteHttpBase {
  constructor(
    private readonly dependencias: DependenciasClienteHttpCondominio,
    dependenciasInternas: DependenciasInternasHttp = {},
  ) {
    super({
      servico: 'condominio',
      urlBase: dependencias.urlBase,
      urlFallback: dependencias.urlFallback,
      timeoutMs: dependencias.timeoutMs ?? TIMEOUT_PADRAO_MS,
    }, dependenciasInternas)
  }

  protected override prepararRequisicao(requisicao: RequisicaoHttp): RequisicaoHttp {
    const credenciais = this.dependencias.obterCredenciais()
    const authorization = obterValorPreenchido(credenciais?.authorization)
    const accessToken = obterValorPreenchido(credenciais?.accessToken)
    const userPoolId = accessToken
      ? obterValorPreenchido(credenciais?.userPoolId)
      : undefined
    const userPoolWebClientId = accessToken
      ? obterValorPreenchido(credenciais?.userPoolWebClientId)
      : undefined
    const perfilAcesso = obterValorPreenchido(this.dependencias.obterPerfilAcesso())
    const idioma = obterValorPreenchido(this.dependencias.obterIdioma())

    return {
      ...requisicao,
      headers: {
        ...removerHeadersGerenciados(requisicao.headers),
        ...(authorization ? { Authorization: authorization } : {}),
        ...(accessToken ? { 'X-PontoTel-Authorization': accessToken } : {}),
        ...(userPoolId ? { 'X-PontoTel-UP': userPoolId } : {}),
        ...(userPoolWebClientId ? { 'X-PontoTel-DI': userPoolWebClientId } : {}),
        ...(perfilAcesso ? { 'x-perfil-acesso': perfilAcesso } : {}),
        ...(idioma ? { 'Accept-Language': idioma } : {}),
      },
    }
  }
}

export const criarClienteHttpCondominio = (
  dependencias: DependenciasClienteHttpCondominio,
): ClienteHttp => new ClienteHttpCondominio(dependencias)
